import './Fatality.css';

const defaultProps = {
    header: 'Sorry, something went wrong',
    sub: `
            <a href='javascript:history.back();'>Go back</a> and try again.
            <br />
            If the issue continues, check out our <a href='//status.xero.com'>Status Page</a>.
        `,
};

const Fatality = (props: { header?: string; sub?: string | string; errorCode?: number }) => {
    const leProps = { ...defaultProps, ...props };
    const { header, sub, errorCode } = leProps;

    const error = errorCode ? `Error code: ${errorCode}` : '';

    // Mostly a copy/paste of https://github.dev.xero.com/Xero/ErrorPages
    return (
        <div className='fatality'>
            <div className='a'>
                <div className='b'>
                    <div className='c'>
                        <a className='d' tabIndex={-1} href='//xero.com' title='Go to xero.com'>
                            <svg width='60' height='60' viewBox='0 0 30 30' role='presentation'>
                                <g>
                                    <path fill='#FFF' d='M2 11h26v8H2z' />
                                    <path
                                        fill='#2BAAED'
                                        d='M15 0C6.72 0 0 6.72 0 15c0 8.28 6.72 15 15 15 8.28 0 15-6.72 15-15 0-8.28-6.72-15-15-15M9.4 18.3c-.1 0-.23-.05-.32-.14L6.53 15.6l-2.57 2.57c-.1.1-.2.13-.32.13-.26 0-.46-.2-.46-.46 0-.12.05-.24.14-.32l2.56-2.57-2.56-2.56c-.1-.1-.14-.2-.14-.4 0-.3.2-.5.46-.5.12 0 .23.05.32.13l2.57 2.56 2.57-2.5c.04-.1.2-.14.3-.14.24 0 .44.2.44.48 0 .12-.05.23-.13.32l-2.5 2.56 2.5 2.57c.1.1.18.2.18.3 0 .26-.2.46-.46.46m6.16-2.98h-4.8.02c0 .1.04.23.1.35.24.66.95 1.6 2.3 1.6.4 0 .77-.1 1.1-.27.28-.15.5-.34.67-.54l.16-.2c.2-.3.5-.24.7-.1.2.14.2.46 0 .7-.27.34-.54.6-.86.82-.33.2-.67.3-1 .4-.43.1-.8.12-1.23.1-1.35-.2-2.5-1.2-2.83-2.5-.07-.3-.1-.58-.1-.85 0-1.1.5-2.13 1.4-2.77 1.1-.8 2.6-.84 3.76-.1.8.5 1.3 1.25 1.5 2.2.1.52-.22 1-.9 1m3.88-2.76c-1 .1-1.1.6-1.1 1.72v3.5c0 .24-.2.44-.46.44s-.46-.2-.46-.46V12c0-.26.2-.46.46-.46.2 0 .4.12.42.33.36-.27.76-.4 1.2-.4h.13c.24 0 .45.2.45.46s-.2.43-.5.44h-.2m3.8 5.76c-1.8 0-3.32-1.5-3.32-3.33 0-1.86 1.5-3.37 3.35-3.37s3.38 1.5 3.38 3.35-1.5 3.36-3.38 3.36zm-10-5.73c-1.13 0-2.1.8-2.35 1.86v.04h4.73c-.23-1.08-1.2-1.88-2.34-1.88zm10.06.04c-1.34 0-2.4 1.1-2.4 2.42 0 1.33 1.06 2.4 2.4 2.4 1.3 0 2.4-1.07 2.4-2.4 0-1.33-1.1-2.42-2.4-2.42zm0 3.25c-.47 0-.84-.4-.84-.9 0-.48.4-.86.86-.86.47 0 .85.4.85.84 0 .46-.4.83-.84.83z'
                                    />
                                </g>
                            </svg>
                        </a>
                        <h2>{header}</h2>
                        <p dangerouslySetInnerHTML={{ __html: sub }} />
                        <svg width='124' height='124' xlinkHref='http://www.w3.org/1999/xlink' role='presentation'>
                            <defs>
                                <circle id='a' cx='62' cy='62' r='62' />
                            </defs>
                            <g>
                                <mask id='b' fill='#fff'>
                                    <use xlinkHref='#a' />
                                </mask>
                                <use fill='#E6EBF0' xlinkHref='#a' />
                                <g fill='#FFF' stroke='#D0DAE2' strokeWidth='2' mask='url(#b)'>
                                    <path d='M72.6 26H31c-4 0-7 3-7 7v107c0 4 3 7 7 7h63c4 0 7-3 7-7V54.4L72.6 26z' />
                                    <path d='M71 26h1.6L101 54.4V56H78c-4 0-7-3-7-7V26z' />
                                </g>
                                <g fill='#D0DAE2'>
                                    <path
                                        d='M46 105c0-1 1-2 2-2s2 1 2 2c0 1.3-1 2.3-2 2.3s-2-1-2-2.2m30 2.5c-1 0-2-1-2-2.2 0-1 1-2 2-2s2 1 2 2c0 1.3-1 2.3-2 2.3'
                                        className='e'
                                    />
                                    <path d='M61.8 114.4c-8 0-15.8 2.2-15.8 1.5 0-1 3-4 15.8-4 13 0 16 3 16 4 0 .4-8-1.8-16-1.8' />
                                </g>
                            </g>
                        </svg>
                    </div>
                </div>

                <div className='f'>
                    <p>{error}</p>
                    <ul>
                        <li>
                            <a href='//www.xero.com/blog/security-noticeboard'>Security noticeboard</a>
                        </li>
                        <li>
                            <a href='//www.xero.com/about/terms'>Terms of use</a>
                        </li>
                        <li>
                            <a href='//www.xero.com/about/privacy'>Privacy</a>
                        </li>
                        <li>
                            <a href='//help.xero.com'>Help Center</a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    );
};

export default Fatality;
